export const authRoutes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/Login.vue'),
    meta: { public: true, isLoginPage: true },
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('./views/Logout.vue'),
    meta: { public: true },
  },
  {
    path: '/sso/consume',
    name: 'sso-consume',
    component: () => import('./views/SSOConsume.vue'),
    meta: { public: true },
  },
  { path: '/ai-console/login', redirect: { name: 'login' } },
  { path: '/ai-console/logout', redirect: { name: 'logout' } },
];
